import React from "react";
import { format, parse } from "date-fns";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Grid, Typography } from "@mui/material";

const NotificationCard = ({ id, message, date }) => {
  return (
    <Grid item xs={12} md={4} sm={6} lg={4}>
    <Card
      key="1"
      variant="outlined"
      sx={{
        borderRadius: 2,
        boxShadow: 7,
        display: "flex",
        justifyContent: "space-between",
        margin: 0.5,
        marginX:1,
      }}
    >
      <CardContent>
        <Typography
          variant="h2"
          gutterBottom
          style={{
            textDecoration: "none",
            justifyContent: "flex-start",
            display: "flex",
            
          }}
        >
          Notification ID: {id}
        </Typography>
        <Typography
          variant="body1"
          gutterBottom
          sx={{
            display: "flex",
            textAlign: "left", 
          }}
        >
          {message}
        </Typography>
        <Typography
          variant="subtitle1"
          color="primary"
          sx={{
            justifyContent: "flex-start",
            display: "flex",
          }}
        >
          {format(parse(date, "dd-MM-yyyy", new Date()), "dd MMM yyyy")}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
  
  );
};

export default NotificationCard;
